<div
  class="page-as-modal"
  [style]="modalConfigOuterStyle"
  [@modalTransition]="{
  value: modalState,
  params: modalTransitionPresets[modalTransitionPreset],
}"
>
  <div
    class="page-as-modal-content"
    id="page-as-modal"
    [style]="modalContentStyle"
    [ngStyle]="
      currentPageDetail?.pageConfiguration?.isBodyScrollingEnabled
        ? { 'overflow-y': 'auto' }
        : { overflow: 'hidden' }
    "
  >
    @if (closeAction) {
    <div class="close-icon-content" [style]="iconContentStyle">
      <mat-icon
        [svgIcon]="closeIconName"
        class="close-icon m-2"
        [style]="iconStyle"
        (click)="closeModal()"
      ></mat-icon>
    </div>
    } @if (isWorkflow) {
    <finxone-web-frontend-mobile-container
      *ngIf="device === 'mobile' || device === 'tablet'"
      [zoneUrlInput]="zoneUrlName"
      [pageUrlInput]="pageUrlName"
      [isModal]="true"
    >
    </finxone-web-frontend-mobile-container>
    <finxone-web-frontend-desktop-container
      *ngIf="device === 'desktop'"
      [zoneUrlInput]="zoneUrlName"
      [pageUrlInput]="pageUrlName"
      [menuType]="menuTypeForDesktop"
      [parentComponent]="'PageAsModalComponent'"
    >
    </finxone-web-frontend-desktop-container>
    } @else {
    <!-- Outlet for modal -->
    <router-outlet></router-outlet>
    }
  </div>
</div>
<div
  class="page-as-modal-overlay"
  [style]="{ background: backdropColor, opacity: 0.3 }"
  (click)="clickOutSideModal()"
></div>
